(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kahi-reviews"] && !Shopify.designMode) return;
  try {
    
  // All reviews: lazy JSON, star filter (histogram rows), sort, "show more". No framework, ~2 KB.
  class KahiReviewsAll extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-list]');
      this.moreBtn = this.querySelector('[data-more-btn]');
      this.step = Number(this.dataset.step) || 10;
      this.star = null; this.sort = 'top'; this.shown = 0; this.all = null; this.photosOnly = false;
      this.photosBtn = this.querySelector('[data-photos]');
      this.photosBtn.addEventListener('click', () => { this.photosOnly = !this.photosOnly; this.render(true); });
      this.lightbox = this.querySelector('[data-lightbox]');
      this.querySelector('[data-close]').addEventListener('click', () => this.lightbox.close());
      this.lightbox.addEventListener('click', (e) => { if (e.target === this.lightbox) this.lightbox.close(); });
      const bars = this.closest('.k-reviews')?.querySelectorAll('.k-reviews__bars button[data-star]') || [];
      bars.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.star = this.star === btn.dataset.star ? null : btn.dataset.star;
          bars.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.star === this.star)));
          if (this.all) this.render(true); else { this.load(); this.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      });
      this.bars = bars;
      this.querySelector('[data-clear]').addEventListener('click', () => { this.star = null; this.render(true); });
      this.querySelector('[data-sort]').addEventListener('change', (e) => { this.sort = e.target.value; this.render(true); });
      this.moreBtn.addEventListener('click', () => { this.shown += this.step; this.render(false); });
      const io = new IntersectionObserver((entries) => { if (entries.some((en) => en.isIntersecting)) { io.disconnect(); this.load(); } }, { rootMargin: '600px' });
      io.observe(this);
    }
    async load() {
      if (this.loading) return; this.loading = true;
      try { this.all = await (await fetch(this.dataset.src)).json(); } catch { this.all = []; }
      this.render(true);
    }
    visible() {
      let rows = this.star ? this.all.filter((r) => String(r.s) === this.star) : this.all.slice();
      if (this.photosOnly) rows = rows.filter((r) => r.p && r.p.length);
      const byDate = (a, b) => (b.d > a.d ? 1 : b.d < a.d ? -1 : 0);
      // Top: detail and photos first, a verified badge as a small bonus; ties go to the newest
      const rank = (r) => Math.min(r.b.length, 240) / 80 + (r.p ? 2 : 0) + (r.v ? 0.5 : 0);
      if (this.sort === 'top') rows.sort((a, b) => (rank(b) - rank(a)) || byDate(a, b));
      else if (this.sort === 'highest') rows.sort((a, b) => b.s - a.s || (b.d > a.d ? 1 : -1));
      else if (this.sort === 'lowest') rows.sort((a, b) => a.s - b.s || (b.d > a.d ? 1 : -1));
      else rows.sort((a, b) => (b.d > a.d ? 1 : b.d < a.d ? -1 : 0));
      return rows;
    }
    render(reset) {
      if (!this.all) return;
      if (reset) { this.shown = this.step; this.list.replaceChildren(); }
      const rows = this.visible();
      const fmt = new Intl.DateTimeFormat('en-GB', { month: 'short', year: 'numeric' });
      const icon = this.querySelector('[data-star-icon]').content;
      const frag = document.createDocumentFragment();
      rows.slice(this.list.children.length, this.shown).forEach((r) => frag.appendChild(this.card(r, fmt, icon)));
      this.list.appendChild(frag);
      this.bars.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.star === this.star)));
      this.querySelector('[data-clear]').hidden = !this.star;
      const anyPhotos = this.all.some((r) => r.p && r.p.length);
      this.photosBtn.hidden = !anyPhotos; this.photosBtn.setAttribute('aria-pressed', String(this.photosOnly));
      const title = this.querySelector('[data-title]');
      if (!this.allTitle) this.allTitle = title.textContent;
      title.textContent = this.star ? this.dataset.filtered.replace('%d', rows.length).replace('%s', this.star) : this.allTitle;
      this.querySelector('[data-empty]').hidden = rows.length > 0;
      const left = rows.length - this.list.children.length;
      this.moreBtn.hidden = left <= 0;
      this.moreBtn.textContent = this.dataset.more.replace('%d', Math.min(left, this.step));
    }
    card(r, fmt, icon) {
      const li = document.createElement('li'); li.className = 'k-card k-review';
      const top = el('div', 'k-review__top');
      const stars = el('span', 'k-stars__icons'); stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', r.s + ' out of 5 stars');
      for (let i = 0; i < r.s; i++) stars.appendChild(icon.cloneNode(true));
      const time = el('time', 'k-note'); time.dateTime = r.d; time.textContent = fmt.format(new Date(r.d));
      top.append(stars, time); li.appendChild(top);
      if (r.t) { const h = el('h4', 'k-review__title'); h.textContent = '\u201C' + r.t + '\u201D'; li.appendChild(h); }
      const q = el('blockquote', 'k-review__body'); const pEl = document.createElement('p'); pEl.textContent = r.b; q.appendChild(pEl); li.appendChild(q);
      if (r.o) {
        const toggle = el('button', 'k-review__orig'); toggle.type = 'button'; toggle.textContent = this.dataset.seeOriginal;
        toggle.setAttribute('aria-pressed', 'false');
        toggle.addEventListener('click', () => {
          const showing = toggle.getAttribute('aria-pressed') === 'true';
          pEl.textContent = showing ? r.b : r.o; pEl.lang = showing ? 'en' : 'ko';
          toggle.textContent = showing ? this.dataset.seeOriginal : this.dataset.seeTranslation;
          toggle.setAttribute('aria-pressed', String(!showing));
        });
        li.appendChild(toggle);
      }
      // https only: the photo URLs come from imported review data
      const photos = (r.p || []).filter((u) => /^https:\/\//.test(u));
      if (photos.length) {
        const strip = el('div', 'k-review__photos');
        photos.slice(0, 3).forEach((src) => {
          const btn = el('button', 'k-review__photo'); btn.type = 'button';
          const img = document.createElement('img'); img.loading = 'lazy'; img.decoding = 'async'; img.src = src; img.alt = ''; img.width = 72; img.height = 72;
          btn.appendChild(img); btn.addEventListener('click', () => { this.querySelector('[data-lightbox-img]').src = src; this.lightbox.showModal(); });
          strip.appendChild(btn);
        });
        li.appendChild(strip);
      }
      const by = el('div', 'k-review__by');
      const a = el('span', 'k-review__author'); a.textContent = r.a;
      const badge = el('span', r.v ? 'k-review__verified' : 'k-review__src');
      badge.textContent = r.src === 'UK' ? (r.v ? this.dataset.verified : this.dataset.uk)
        : (r.v ? this.dataset.verified + ' · ' : '') + this.dataset.store.replace('%s', r.src) + (r.o ? ' · ' + this.dataset.translated : '');
      by.append(a, badge); li.appendChild(by);
      return li;
      function el(tag, cls) { const e = document.createElement(tag); e.className = cls; return e; }
    }
  }
  if (!customElements.get('kahi-reviews-all')) customElements.define('kahi-reviews-all', KahiReviewsAll);

  } catch(e) { console.error(e); }
})();
})();
